import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import SingleSlider from '../../components/Slider';

import sliderImg1 from '../../assets/img/slider/slide-1-1.jpg';
import sliderImg2 from '../../assets/img/slider/slide-1-2.jpg';
import sliderImg3 from '../../assets/img/slider/slider-1-4.jpg';
import sliderImg5 from '../../assets/img/slider/slider-1-10.jpg';

const Hero = () => {
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '1',
    autoplay: {
      delay: 5000,
    },
    effect: 'fade',
  };

  return (
    <div className="it-slider-area it-slider-overley fix p-relative z-index">
      <div className="it-slider-wrap">
        <div className="swiper-container it-slider-active">
          <Swiper
            modules={[Navigation, EffectFade, Autoplay]}
            {...sliderOption}
            className="swiper-wrapper"
          >
            <SwiperSlide className="swiper-slide">
              <SingleSlider
                sliderImage={sliderImg5}
                title="Caring Hearts, Healing Hands Our Cardiology Practice"
                description={`Welcome to RIC, where compassionate care meets advanced cardiovascular expertise. Our dedicated team of specialists is committed to providing the highest standard of treatment for your heart health.`}
                 btnTextTwo="Read More"
                btnTextOne="Book Appointment"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <SingleSlider
                sliderImage={sliderImg1}
                title="Caring Hearts, Healing Hands Our Cardiology Practice"
                description={`Welcome to RIC, where compassionate care meets advanced cardiovascular expertise. Our dedicated team of specialists is committed to providing the highest standard of treatment for your heart health.`}
                 btnTextTwo="Read More"
                btnTextOne="Book Appointment"
              />
            </SwiperSlide>
           
            <SwiperSlide className="swiper-slide">
              <SingleSlider
                sliderImage={sliderImg2}
                title="Caring Hearts, Healing Hands Our Cardiology Practice"
                description={`We are committed to offering comprehensive cardiovascular care to all individuals, regardless of their background or financial status. As a government hospital, we take pride in providing most of our services free of charge, ensuring accessible healthcare for every community.`}
                btnTextTwo="Read More"
                btnTextOne="Book Appointment"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Hero;
